export function getUserTypePath (userType) {
  if (userType) {
    return userType === 'candidate' ? 'candidates' : 'analysts'
  }

  return null
}
